"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _box = require("@oneloop/box");
var _theme = _interopRequireDefault(require("@oneloop/theme"));
var _text = require("@oneloop/text");
var _icons = require("@oneloop/icons");
var _excluded = ["children", "variant", "modalBG", "blockScroll", "closeModal", "scrollHeight", "fixedCLoseBtn", "paddings"],
  _excluded2 = ["closeIcon", "variant", "text", "textSize"],
  _excluded3 = ["variant"];
/* eslint-disable multiline-ternary */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var Modal = exports.Modal = function Modal(_ref) {
  var children = _ref.children,
    variant = _ref.variant,
    modalBG = _ref.modalBG,
    _ref$blockScroll = _ref.blockScroll,
    blockScroll = _ref$blockScroll === void 0 ? false : _ref$blockScroll,
    _ref$closeModal = _ref.closeModal,
    closeModal = _ref$closeModal === void 0 ? false : _ref$closeModal,
    _ref$scrollHeight = _ref.scrollHeight,
    scrollHeight = _ref$scrollHeight === void 0 ? '600px' : _ref$scrollHeight,
    _ref$fixedCLoseBtn = _ref.fixedCLoseBtn,
    fixedCLoseBtn = _ref$fixedCLoseBtn === void 0 ? false : _ref$fixedCLoseBtn,
    _ref$paddings = _ref.paddings,
    paddings = _ref$paddings === void 0 ? '24px' : _ref$paddings,
    props = _objectWithoutProperties(_ref, _excluded);
  var modalRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (blockScroll) {
      document.body.style.overflow = 'hidden';
      return function () {
        return document.body.style.overflow = 'auto';
      };
    }
  }, []);
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Escape' && document.activeElement === modalRef.current) {
      event.stopPropagation();
      closeModal();
    }
  };
  (0, _react.useEffect)(function () {
    if (closeModal) {
      document.addEventListener('keydown', handleKeyDown);
    }
    return function () {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (closeModal && modalRef.current) {
      modalRef.current.focus();
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_box.Box, {
    tabIndex: -1,
    ref: modalRef,
    __css: {
      position: 'fixed',
      zIndex: '1000',
      width: '100%',
      height: '100%',
      top: '0',
      left: '0',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, modalBG && /*#__PURE__*/_react["default"].createElement(_box.Box, {
    onClick: closeModal || undefined,
    __css: {
      backgroundColor: '#485C66',
      opacity: '0.7',
      width: '100%',
      height: '100%',
      position: 'absolute',
      zIndex: '-1'
    }
  }), /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    as: "div",
    tx: "modals"
  }, props, {
    __css: {
      position: 'relative',
      maxWidth: '900px',
      minWidth: '380px !important',
      height: "".concat(scrollHeight),
      background: _theme["default"].colors.white,
      borderRadius: '16px',
      boxSizing: 'border-box',
      boxShadow: '8px 8px 16px rgba(77, 91, 100, 0.15)'
    },
    variant: variant
  }), fixedCLoseBtn && /*#__PURE__*/_react["default"].createElement(_box.Box, {
    onClick: closeModal,
    __css: {
      width: '24px',
      height: '24px',
      backgroundColor: '#FFF',
      position: 'absolute',
      borderRadius: '50%',
      top: '-7px',
      right: '-7px',
      display: 'grid',
      placeItems: 'center',
      cursor: 'pointer',
      boxShadow: '4px 4px 12px 0px rgba(87, 95, 99, 0.25)',
      zIndex: '1000'
    }
  }, /*#__PURE__*/_react["default"].createElement(_icons.Icon, {
    icon: "icon-cerrar",
    fontSize: "12px",
    color: _theme["default"].colors.neutralGray1
  })), /*#__PURE__*/_react["default"].createElement(_box.Box, {
    __css: {
      padding: paddings,
      display: 'flex',
      flexDirection: 'column',
      gap: '24px',
      height: "".concat(scrollHeight)
    }
  }, children)));
};
var ModalHeader = function ModalHeader(_ref2) {
  var closeIcon = _ref2.closeIcon,
    variant = _ref2.variant,
    text = _ref2.text,
    textSize = _ref2.textSize,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    justifyContent = _useState2[0],
    setJustifyContent = _useState2[1];
  var headerRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    setJustifyContent(headerRef.current.childElementCount > 1 ? 'space-between' : variant[0]);
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_box.Flex, _extends({
    as: "div",
    tx: "modals",
    ref: headerRef,
    variant: variant[1],
    __css: {
      justifyContent: justifyContent,
      alignItems: 'center'
    }
  }, props), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    style: {
      fontWeight: '700',
      color: _theme["default"].colors.neutralGray1
    }
  }, text), closeIcon && /*#__PURE__*/_react["default"].createElement(_icons.Icon, {
    style: {
      cursor: 'pointer'
    },
    icon: "icon-cerrar",
    fontSize: "18px",
    color: _theme["default"].colors.neutralGray5,
    onClick: closeIcon
  }));
};
var ModalBody = function ModalBody(props) {
  return /*#__PURE__*/_react["default"].createElement(_box.Box, props);
};
var ModalFooter = function ModalFooter(_ref3) {
  var _ref3$variant = _ref3.variant,
    variant = _ref3$variant === void 0 ? 'start' : _ref3$variant,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_react["default"].createElement(_box.Flex, _extends({
    as: "div",
    tx: "modals",
    __css: {
      justifyContent: variant,
      alignItems: 'center',
      gap: '24px'
    }
  }, props));
};
Modal.Header = ModalHeader;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;